module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_map_white-7345cba0ed6a1c31fe8ecd7cda1616c6.svg";